import JSZip from 'jszip'
import { Loading } from 'element-ui';
import reg from './reg'
import FileSaver from "file-saver"

class UnpackAndDownImage {

  constructor(option){
    const opt = {
      imgSrcList:[], // 图片资源集合
      imgBase64:[], // 图片base64集合
      imageSuffix: [], // 图片后缀
      imgName:[], // 下载后的图片名称集合
      scheduleMsg:'', // 下载进度
      errorMsg:"" , //异常信息
      folderName:"",
      loading:null,
      onProgress: this.onProgress,
      onSuccess: this.onSuccess,
      onError: this.onError,
    }

    this.option = Object.assign({}, opt, option)
    this.option.loading = Loading.service({
        lock: true,
        text: '正在为您压缩中,请稍等',
        background: 'rgba(0, 0, 0, 0.7)'
      });
    this.start()
  }

  start(){
    let count = 0;
    let arr = []
    this.option.imgSrcList.forEach(item=>{
        this.option.imageSuffix.push('.png');
        this.option.imgName.push(item)   
        count+=1
        this.option.scheduleMsg = count + '/' + this.option.imgSrcList.length
        this.option.onProgress&&this.option.onProgress(this.option.scheduleMsg)

    })
    this.zipSaveFile()
  }
  //传入图片路径，返回base64
  getBase64(img) {
    return new Promise((resolve,reject)=>{
      const image = new Image();
      image.crossOrigin = 'Anonymous';
      image.src = img;
      if(img){
        image.onload =()=>{
          resolve(this.getBase64Image(image)) //将base64传给done上传处理
        }
      }else{
        reject("转换base64失败")
      }
    })
  }

  getBase64Image(img, width, height) {
    //width、height调用时传入具体像素值，控制大小 ,不传则默认图像大小
    let canvas = document.createElement("canvas");
    canvas.width = width ? width : img.width;
    canvas.height = height ? height : img.height;
    let ctx = canvas.getContext("2d");
    ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
    let dataURL = canvas.toDataURL("image/jpeg", 0.9);
    return dataURL;
  }

  /** 打包并下载 */
  zipSaveFile(){
    let zip = new JSZip();
    // zip.file("readme.txt", "案件详情资料\n");
    let img = zip.folder();
    setTimeout(()=>{
      if(this.option.imgSrcList.length == this.option.imgBase64.length){
        this.option.imgSrcList.forEach((imgItem,i)=>{
          img.file(reg.getUrlName(imgItem), this.option.imgBase64[i].replace(/^data:image\/(png|jpg|jpeg);base64,/, ""), {base64: true})
        })
        zip.generateAsync({type:"blob"}).then((content)=> {
        this.option.loading.close();
        
          let fileName = this.option.folderName +'.zip'
          // see FileSaver.js
          status = saveAs(content, fileName);
          
          this.option.onSuccess&&this.option.onSuccess()

          this.option.scheduleMsg = ""
        });
      }else{
        this.zipSaveFile();
      }
   },100);
  }

  onProgress(res) {
    console.log('onProgress',res);
  }

  onSuccess(res) {
    this.option.loading.close();
    console.log('onSuccess:',res)
  }

  onError(res) {
    this.option.loading.close();
    console.error('onError',res)
  }

}

export default UnpackAndDownImage;
